/* eslint-disable no-inner-declarations */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-promise-reject-errors */
import { DEFAULT_OPTIONS } from '#/constants';

export * from './router';
export * from './tool';

// service搭配useRequest的时候需要包一层
export const fetchWrapper =
  (service) =>
  (...args) =>
    service(...args).then((data) => ({ code: 0, data }));

export const getEnvIsGray = () => {
  const host = window.location.host;
  return host.indexOf('dev.') !== -1 || host.indexOf('gray.') !== -1;
};

export const getTargeOptLabel = (options, value) =>
  (options || []).find((item) => item.value === value)?.label || value;

export const passwordValidator = (_, value) => {
  if (!value) {
    return Promise.reject('Cannot be empty');
  }
  if (value.length < 8) {
    return Promise.reject('Password length cannot be less than 8');
  }

  if (value.length > 20) {
    return Promise.reject('Password length should be less than 20');
  }

  if (!/^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*)(?=.*[`~!@#$%^&*()_\-+=<>.?:"{}].*).{6,20}$/.test(value)) {
    return Promise.reject(
      'The password must include uppercase and lowercase letters, numbers and special characters.',
    );
  }
  return Promise.resolve();
};

export const serializeObj = (obj) =>
  Object.keys(obj)
    .filter((key) => obj[key] !== undefined)
    .map((key) => `${key}=${obj[key]}`)
    .join('&');

export function getQueryParams(query) {
  const params = new URLSearchParams(query);
  const obj = {};
  for (const key of params.keys()) {
    obj[key] = params.get(key);
  }
  return obj;
}

export const decoratOptions = (options) => [DEFAULT_OPTIONS, ...options];

export const formatDate = (date) => moment(date).format('YYYY-MM-DD hh:mm');

export const formatNum = (num) => num.toLocaleString();

export const formatPercent = (num) => `${+(num * 100).toFixed(2)}%`;

export const formatFlowNum = (num) => {
  if (num >= 1000) {
    num /= 1000;
    num = +num.toFixed(0);
    return `${num.toLocaleString()}M`;
  }
  return num;
};

export const formatWnum = (val) => {
  if (val >= 10000) {
    return `${(+(val / 10000).toFixed(0)).toLocaleString()}W`;
  }
  return val.toLocaleString();
};

export const formatChartNumWithDecimal = (num) => {
  num = num.toFixed(2);
  num = num.split('.');
  return `${(+num[0]).toLocaleString()}.${num[1]}`;
};

export const formatChartPercentNumWithDecimal = (num) => {
  num = (num * 100).toFixed(2);
  num = num.split('.');
  return `${num}%`;
};

export const formatNumAutoHideDecimal = (num) => {
  const nums = `${num}`.split('.');
  if (nums.length > 1) {
    return `${(+nums[0]).toLocaleString()}.${(+`0.${nums[1]}`).toFixed(2).slice(2)}`;
  }
  return `${(+nums[0]).toLocaleString()}.00`;
};

export const formatNum2String = (num) => {
  if (num > 9) {
    return `${num}`;
  } else {
    return `0${num}`;
  }
};

export const getTableHeadWidth = (postion, defaultWidth, headText) => {
  const ele = document.querySelector(`.media-library .media-table thead th:nth-child(${postion})`);
  if (ele) {
    if (ele.innerText.trim() === headText) {
      const { width } = ele.getBoundingClientRect();
      return width - 24 > defaultWidth ? width - 24 : defaultWidth;
    } else {
      const eles = document.querySelectorAll(`.media-library .media-table thead th`);
      const targetEle = Array.from(eles).find((item) => item.innerText.trim() === headText);
      if (targetEle) {
        const { width } = targetEle.getBoundingClientRect();
        return width - 24 > defaultWidth ? width - 24 : defaultWidth;
      }
    }
  }
  return defaultWidth;
};

export function getFiltersHashStr(hashKey, params, isNewHash = true) {
  const newHashParams = new URLSearchParams(isNewHash ? '' : window.location.hash.slice(1));
  newHashParams.set(hashKey, JSON.stringify(params));
  // 将更新后的hash参数设置到浏览器的hash中
  return `#${newHashParams.toString()}`;
}

function deleteSomeHashProperty(params) {
  const delKeys = ['isEditorShow', 'singleEdit', 'seriesIds'];
  delKeys.forEach((key) => {
    if (!params[key]) {
      delete params[key];
    }
  });

  return JSON.parse(JSON.stringify(params));
}

export function setFiltersToHash(hashKey, params, delKeys = []) {
  // URLSearchParams 会自动进行编码
  const newHashParams = new URLSearchParams(window.location.hash.slice(1));
  params = deleteSomeHashProperty(params, delKeys);
  if (JSON.stringify(params || {}) !== '{}') {
    newHashParams.set(hashKey, JSON.stringify(params));
    // 将更新后的hash参数设置到浏览器的hash中
    // window.location.hash = `#${newHashParams.toString()}`;
    window.history.pushState({}, '', `#${newHashParams.toString()}`);
    // 同时需要触发一次 dispacth 更新路由的数据

    // 获取当前的hash值
    const currentHash = window.location.hash;
    // 解析当前的hash值
    const currentHashParams = new URLSearchParams(currentHash.slice(1));

    function parseSearchParams(searchParams) {
      const result = {};
      for (const [key, value] of searchParams.entries()) {
        result[key] = value;
      }
      return result;
    }

    // 当触发了 popstate 事件后，主动发出 adsHashChange 事件，在子系统当中进行事件接收
    // 将 hash 当中存储的筛选参数通过事件进行传递
    const evt = new CustomEvent('adsHashChange', {
      detail: parseSearchParams(currentHashParams),
    });
    window.dispatchEvent(evt);
  }
}

export function getFiltersFromHash(hashKey, defaultParams = {}) {
  // 获取当前的hash值
  const currentHash = window.location.hash;
  // 解析当前的hash值
  const currentHashParams = new URLSearchParams(currentHash.slice(1));
  const hashParamsStr = currentHashParams.get(hashKey);
  if (!hashParamsStr) {
    return defaultParams;
  }
  const hashParams = JSON.parse(
    hashParamsStr && hashParamsStr !== 'null' ? hashParamsStr : JSON.stringify(defaultParams),
  );
  return hashParams;
}

export function deleteKeys(obj, keys = []) {
  keys.forEach((key) => {
    delete obj[key];
  });
}

/**
 * 比较从 hash 取出的筛选值和当前页面的筛选值是否相同
 * @param {object} newFilters 从 hash 获取的筛选值
 * @param {object} oldFilters 当前最新的筛选值
 * @returns {boolean} true 筛选值相同 / false 筛选值不同
 */
export function isSameFilters(newFilters = {}, oldFilters, deleteKeysArr) {
  if (deleteKeysArr?.length > 0) {
    // 删除不需要比较的数据
    deleteKeys(newFilters, deleteKeysArr);
    deleteKeys(oldFilters, deleteKeysArr);
  }

  const newFilterKeys = Object.keys(newFilters);
  const oldFilterKeys = Object.keys(oldFilters);
  if (newFilterKeys.length !== oldFilterKeys.length) {
    return false;
  }

  for (let idx = 0; idx < newFilterKeys.length; idx++) {
    const key = newFilterKeys[idx];
    if (JSON.stringify(oldFilters[key]) !== JSON.stringify(newFilters[key])) {
      return false;
    }
  }
  return true;
}

export const loadImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.src = url;

    image.onload = () =>
      resolve({
        width: image.width,
        height: image.height,
      });
    image.onerror = reject;
  });

export const getNormalTableHeight = (deviation = 0) =>
  window.innerHeight - 54 - 14 - 36 - 16 - 56 - 52 - 8 - 20 - deviation;
